export function LogoMark({ className = 'h-7 w-7' }) {
  return (
    <img
      src="/assets/brand/rangesafe-icon.png"
      alt="RangeSafe"
      className={className}
      data-testid="logo-mark"
    />
  );
}

export default function Logo({ compact = false }) {
  return (
    <span className="flex items-center gap-3 text-white">
      <img
        src="/assets/brand/rangesafe-logo.png"
        alt="RangeSafe"
        className="h-8 w-auto sm:h-9"
        data-testid="logo-image"
      />
      {!compact && (
        <span className="border-l border-line pl-3 font-mono text-[9px] uppercase leading-relaxed tracking-[0.3em] text-dim">
          Commercial
          <br />
          Solutions
        </span>
      )}
    </span>
  );
}
